import React from 'react';
import { AppPage, MimaButton, PageLoader, Searchbar } from '../../components';
import styles from '../../assets/styles/BusinessCategory/BusinessCategory.module.scss';
import { AddExpenseCategoryContainer, AddNewCategoryContainer, DeleteCategoryContainer, DeleteExpenseCategoryContainer, EditCategoryContainer, EditExpenseCategoryContainer } from '../../containers';
import { AnimatePresence } from 'framer-motion';
import MimaOptionMenu from '../../components/OptionMenu';
import { useState } from 'react';
import moment from 'moment';


const ExpenseCategory = ({
    deleteExpCategoryModal,
    goToDeleteExpCategoryModal,
    loading,
    goToAddExpCategoryModal,
    addExpCategoryModal,
    closeModal,
    goToEditExpCategoryModal,
    editExpCategoryModal,
    expenseCategoryList,
}) => {
    const [filteredExpCategories, setFilteredExpCategories] = useState([]);
    const [data, setData] = useState({});

    return (
        <AppPage pageTitle="Expense Category">
            {loading ? (
                <PageLoader title="while we load your information" />
            ) : (
                <div>
                    <div className={styles.searchMidle}>
                        <Searchbar
                            variant="wide"
                            placeholder="Search"
                            height={5}
                            input={expenseCategoryList}
                            output={setFilteredExpCategories}
                            handleFilter={(item, searchQuery) => {
                                return item?.name.toLowerCase()?.includes(searchQuery)
                            }}
                        />
                        <MimaButton
                            title="Add New Category"
                            width={30}
                            hight={10}
                            onClick={goToAddExpCategoryModal}

                        />
                    </div>

                    <div className='whiteTable'>
                        <table>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Category Name</th>
                                    <th>Description</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredExpCategories.map(item => (
                                    <tr key={item._id}>
                                        <td>{moment(item?.createdAt).format("DD/MM/YYYY HH:mm a")}</td>
                                        <td>{item?.name}</td>
                                        <td>{item?.description}</td>
                                        <td>
                                            <div className='tableAction__text'>
                                                <MimaOptionMenu
                                                    options={[
                                                        {
                                                            label: "Edit",
                                                            value: "EDIT"
                                                        },
                                                        {
                                                            label: "Delete",
                                                            value: "DELETE"
                                                        }
                                                    ]}
                                                    onOptionSelected={option => {
                                                        setData(item);
                                                        if (option.value === "EDIT") {
                                                            goToEditExpCategoryModal();
                                                        } else if (option.value === "DELETE") {
                                                            goToDeleteExpCategoryModal()
                                                        }
                                                    }}
                                                />

                                            </div>
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {(addExpCategoryModal ||
                        editExpCategoryModal ||
                        deleteExpCategoryModal) && (
                            <di className="modal">
                                <AnimatePresence>
                                    {addExpCategoryModal && (
                                        <AddExpenseCategoryContainer closeModal={closeModal} data={data} />
                                    )}
                                    {editExpCategoryModal && (
                                        <EditExpenseCategoryContainer closeModal={closeModal} data={data} />
                                    )}
                                    {deleteExpCategoryModal && (
                                        <DeleteExpenseCategoryContainer closeModal={closeModal} data={data} />
                                    )}
                                </AnimatePresence>
                            </di>

                        )}
                </div>
            )}
        </AppPage>
    )
}
export default ExpenseCategory;